import { render, staticRenderFns } from "./CncBadgeNumber.vue?vue&type=template&id=39fea5cf"
import script from "./CncBadgeNumber.vue?vue&type=script&lang=js"
export * from "./CncBadgeNumber.vue?vue&type=script&lang=js"
import style0 from "./CncBadgeNumber.vue?vue&type=style&index=0&id=39fea5cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports